module.exports = __webpack_public_path__ + "static/img/logo@2x.8a99cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/logo@2x.png
// module id = yyx2
// module chunks = 70